import api from "./api";

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const filenameFromDisposition = (disposition, fallback) => {
  if (!disposition) return fallback;
  const match = disposition.match(/filename="?([^"]+)"?/i);
  return match?.[1] || fallback;
};

export const messagesApi = {
  getSmsMessages: (params) => api.get("/messages/sms", { params }),

  updateSmsStatus: (tblId, payload) =>
    api.patch(`/messages/sms/${encodeURIComponent(tblId)}/status`, payload),

  getPendingCount: () => api.get("/messages/pending-count"),

  getCustomerFeedbacks: (params = {}) =>
    api.get("/messages/customer-feedbacks", { params }),

  getApprovalRequests: (params) =>
    api.get("/messages/approval-requests", { params }),

  getApprovalRequestDetail: (id) =>
    api.get(`/messages/approval-requests/${encodeURIComponent(id)}`),

  getApprovalStatusNotifications: (trackedIds = []) =>
    api.post("/messages/approval-status-notifications", {
      tracked_ids: trackedIds,
    }),

  exportCompletedMessages: async (params) => {
    const response = await api.get("/messages/sms/export", {
      params,
      responseType: "blob",
    });
    const filename = filenameFromDisposition(
      response.headers?.["content-disposition"],
      "completed_messages.csv"
    );
    downloadBlob(response.data, filename);
  },

  exportApprovalRequests: async (params) => {
    const response = await api.get("/messages/approval-requests/export", {
      params,
      responseType: "blob",
    });
    const filename = filenameFromDisposition(
      response.headers?.["content-disposition"],
      "approval-requests.xls"
    );
    downloadBlob(response.data, filename);
  },
};

export default messagesApi;
